import { createInertiaApp } from '@inertiajs/react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import '../styles/application.css'
import { applyTheme, getInitialTheme } from '../lib/theme'
import { PersistentCallProvider } from '../lib/persistent-call'
import { LiveCallFloater } from '../components/live/live-call-floater'

if (typeof document !== 'undefined') {
  applyTheme(getInitialTheme())
}

// strictMode intentionally disabled: it double-mounts every component in
// development, which collides with WebRTC state (RTCPeerConnection /
// MediaStream / signaling). Production never double-mounts; turning this
// back on requires the call hook to be idempotent across remounts.
createInertiaApp({
  pages: '../pages',
  strictMode: false,
  progress: { color: '#C2492B' },
  title: (title) => (title ? `${title} · stgbee` : 'stgbee'),
  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
    visitOptions: () => ({ queryStringArrayFormat: 'brackets' }),
  },
  // Custom root setup so PersistentCallProvider sits ABOVE the Inertia
  // page tree. That means an active call (its WebRTC peer + streams)
  // survives every Inertia visit — the user can click /feed or /people
  // while still on a live call, and the LiveCallFloater renders the
  // mini-window over whatever page is current.
  setup({ el, App, props }) {
    const tree = (
      <PersistentCallProvider>
        <App {...props} />
        <LiveCallFloater />
      </PersistentCallProvider>
    )
    if (el.hasChildNodes()) {
      hydrateRoot(el, tree)
    } else {
      createRoot(el).render(tree)
    }
  },
}).catch((error) => {
  if (document.getElementById('app')) {
    throw error
  } else {
    console.error('Missing #app root element')
  }
})
